import React from 'react';
import useLanguageContext from '~/contexts/language';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import './language-selector.scss';
const polishSite = 'https://openstax.pl/podreczniki';
export function LanguageLink({ locale, slug }) {
    const { setLanguage } = useLanguageContext();
    const onClick = React.useCallback((event) => {
        event.preventDefault();
        setLanguage(locale);
    }, [locale, setLanguage]);
    const href = slug ? `/subjects/${slug}/` : locale;
    const props = locale === 'pl' ? { href: polishSite, target: '_blank' } : { href, onClick };
    return (React.createElement("a", Object.assign({}, props),
        React.createElement(LanguageText, { locale: locale })));
}
export function LanguageText({ locale }) {
    const { language } = useLanguageContext();
    const text = React.useMemo(() => (new Intl.DisplayNames([language], { type: 'language' })).of(locale), [language, locale]);
    return text;
}
function AnotherLanguage({ locale, LinkPresentation, position, listLength }) {
    return (React.createElement(React.Fragment, null,
        listLength > 1 ? ', ' : ' ',
        position === listLength ?
            React.createElement(FormattedMessage, { id: "and", defaultMessage: "and" }) : null,
        ' ',
        React.createElement(LinkPresentation, { locale: locale })));
}
export function LanguageSelectorWrapper({ children }) {
    return (React.createElement("div", { className: "language-selector" },
        React.createElement(FontAwesomeIcon, { icon: faGlobe }),
        React.createElement("span", null, children)));
}
export default function LanguageSelector({ LeadIn, otherLocales, LinkPresentation = LanguageLink, addPolish = false }) {
    if (addPolish) {
        otherLocales.push('pl');
    }
    const { language } = useLanguageContext();
    if (otherLocales.length < 1) {
        return null;
    }
    return (React.createElement(LanguageSelectorWrapper, null,
        React.createElement(LeadIn, null),
        ' ',
        React.createElement(LanguageText, { locale: language }),
        otherLocales.map((lo, i) => React.createElement(AnotherLanguage, { key: lo, locale: lo, LinkPresentation: LinkPresentation, position: i + 1, listLength: otherLocales.length }))));
}
